import { render, staticRenderFns } from "./ExportTongji.vue?vue&type=template&id=6a5ecaa8&scoped=true&"
import script from "./ExportTongji.vue?vue&type=script&lang=js&"
export * from "./ExportTongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ecaa8",
  null
  
)

export default component.exports